import { Link } from "react-router-dom";
import {
  Button,
  Container,
  Row,
  Col,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import { useGetImagesQuery, useGetVideosQuery } from "../../app/services/api";
import { EditMediaListItem } from "./EditMediaListItem";

export const EditMediaList = ({ type }) => {
  const { data: images, isLoading: isLoadingImages } = useGetImagesQuery();
  const { data: videos, isLoading: isLoadingVideos } = useGetVideosQuery();
  const media = type === "img" ? images : videos;

  const mediaType = type === "img" ? "face" : "video";

  return isLoadingImages || isLoadingVideos ? (
    <Container className="my-3">
      <Row>
        <Spinner>Loading...</Spinner>
      </Row>
    </Container>
  ) : (
    <Container className="mt-3">
      <Row>
        <Col>
          <h2>Edit {mediaType}s</h2>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col align="left">
          <Button as={Link} variant="secondary" to="/home">
            Back
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <ListGroup className="edit-media-list-group" variant="flush">
            {media
              ?.filter((item) => item.status !== "FAIL")
              .map((item) => (
                <EditMediaListItem key={item.id} type={type} item={item} />
              ))}
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
};
